<template>

  <div class="home">
    <Navbar :is-active="1"></Navbar>
    <div class="body">
      <CommercialSidebar active="sucursales" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Sucursales / <span>Ver sucursal</span></h2>
        </div>
        <div class="page__subtitle">
          <h3>Información </h3>
        </div>
        <section class="page__filters first">
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de Registro</p>
            <span>{{ hoy }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de Actualización</p>
            <span> - </span>
          </div>
          <div class="input">
            <p>Dentro de mall</p>
            <select v-model="branch_inside_mall">
              <option disabled value="">Seleccionar</option>
              <option value=1>Si</option>
              <option value=0>No</option>
            </select>
          </div>
          <div class="input" v-if="branch_inside_mall == '1'">
            <p>Nombre de mall</p>
            <input type="text" v-model="branch_name_mall">
          </div>
          <div class="input" style="width: 620px !important;" v-if="branch_inside_mall == '1'">
            <p>Dirección de mall</p>
            <input type="text" v-model="branch_direction_mall" >
          </div>
          <div class="input">
            <p>Código sucursal</p>
            <input type="text" v-model="branch_code"  @keypress="onlynumber(e)" maxlength="10">
          </div>
          <div class="input">
            <p>Nombre sucursal</p>
            <input type="text" v-model="branch_name">
          </div>
          <div class="input">
            <p>Alias</p>
            <input type="text" v-model="branch_nickname">
          </div>
          <div class="input" style="width: 940px; !important;">
            <p>Referencia</p>
            <input type="text" v-model="branch_reference">
          </div>
          <div class="input">
            <p>Descripción </p>
            <textarea v-model="branch_description" rows="4" cols="50"></textarea>
          </div>
        </section>
<!--        <div class="page__subtitle">-->
<!--          <h3>Imágen de Sucursal</h3>-->
<!--        </div>-->
<!--        <section class="page__product">-->
<!--          <div class="product__image">-->
<!--            <img :src="imagen" alt="Subir imagen">-->
<!--          </div>-->
<!--          <div class="product__buttons">-->

<!--            <button>-->
<!--              <span>Cargar Imagen</span>-->
<!--              <i class="fas fa-upload"></i>-->
<!--              <input type="file" id="input_file" value="" @change="change_file" ref="fileupload">-->
<!--            </button>-->

<!--            <button @click="deleteImagen()">-->
<!--              <span>Eliminar Imagen</span>-->
<!--              <i class="far fa-trash-alt"></i>-->
<!--            </button>-->
<!--          </div>-->
<!--        </section>-->
        <div class="page__subtitle">
          <h3>Ubicación</h3>
        </div>
        <section class="page__filters">
          <div class="input">
            <p>Pais</p>
            <input type="text" v-model="branch_pais_id">
          </div>
          <div class="input">
            <p>Departamento</p>
            <select v-model="branch_dep_id" @change="dataDepartamento()">
              <option v-for="deparment in departments" :value="deparment.id">{{ deparment.name }}</option>
            </select>
          </div>
          <div class="input">
            <p>Provincia</p>
            <select v-model="branch_pro_id" @change="dataProvincia()">
              <option v-for="province in provincesOptions" :value="province.id">{{ province.name }}</option>
            </select>
          </div>
          <div class="input">
            <p>Distrito</p>
            <select v-model="branch_dis_id" @change="dataUbigeo()">
              <option v-for="distrito in districtsOptions" :value="distrito.id">{{ distrito.name }}</option>
            </select>
          </div>
          <div class="input">
            <p>Ubigeo</p>
            <input type="text" v-model="ubigeo">
          </div>
          <div class="input">
            <p>Longitud</p>
            <input type="text" v-model="branch_length">
          </div>
          <div class="input">
            <p>Latitud</p>
            <input type="text" v-model="branch_latitude">
          </div>
        </section>

        <GMapMap
            ref="mapRef"
            :center="center"
            :zoom="14"
            map-type-id="terrain"
            style="width: 100%; height: 20rem;"
        >
          <GMapCluster :zoomOnClick="true">
            <GMapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                @click="center = m.position"
            />
          </GMapCluster>
        </GMapMap>
        <div class="ubicacion__buttons">
          <button style="background: #ff3128;" @click="localizacion">
            <span>Cargar  ubicación</span>
            <i class="fas fa-map-marker-alt"></i>
          </button>
        </div>
        <div class="page__subtitle">
          <h3>Lista de productos</h3>
        </div>
        <section class="page__filters" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
          <div class="input" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
            <input style="width: 100%" type="text" v-model="nombre_productoAgregado" placeholder="Buscar nombre de producto">
            <i class="fas fa-search"></i>
          </div>
          <div class="lista_productos__buttons">
           <button style="background: #32ba7c;" @click="showModalFront()">
              <span>Agregar</span>
             <i class="fas fa-plus-circle"></i>
           </button>
            <vue-final-modal v-model="showModal"  classes="modal-container" content-class="modal-content">
              <h2 style="text-align: center">Lista de productos</h2>
              <hr>
              <div class="page__filters">
                <div class="input">
                  <input type="text" placeholder="Código de Productos" v-model="product_code" @keyup="search"/>
                </div>
                <div class="input">
                  <input type="text" placeholder="Nombre del Producto"  v-model="nombre_producto" @keyup="search"/>
                </div>
                <div class="input">
                  <select v-model="product_brand" @change="search">
                    <option selected="selected" value="">Marca</option>
                    <option v-for="valor of brand" :key="valor.id" :value="valor.id">{{ valor.name}}</option>
                  </select>
                </div>
                <div class="input">
                  <select v-model="product_image" @change="search">
                    <option selected="selected" value="">Imagen precargada</option>
                    <option value="1">Si</option>
                    <option value="0">No</option>
                  </select>
                </div>
                <p @click="clean_filters_modal()" class="clean_filter">Limpiar Filtros</p>
              </div>
              <div class="page__table" style="overflow: auto">
                <div class="table-headers">
                  <p v-for="{ label } of columns" :key="label">{{ label }}</p>
                  <p>Agregar</p>
                </div>
                <div class="table-body">
                  <form>
                    <div class="data" v-for="product of productos" :key="product.id">
                      <p>{{product.product_code}}</p>
                      <p>{{product.product_name}}</p>
                      <p>{{product.product_descripcion}}</p>
                      <p>{{product.brand}}</p>
                      <p>{{ conditionalFormatValue(product.product_path) }}</p>
                      <p><input type="checkbox" :name="'product'+product.product_code" @click="saveProducto($event, product)"></p>

                    </div>
                  </form>
                  <div style="text-align: center;" v-if="empty">
                    <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
                  </div>
                </div>
              </div>
              <br>
              <div class="page__pagination">
                <Pagination
                    :data="pagination"
                    v-on:changePage="handleClickInParent"
                />
              </div>
              <br>
              <section class="page__actions">
                <button @click="closeModal">
                  <span>Cancelar</span>
                  <i class="fa fa-times-circle"></i>
                </button>
                <button @click="filterProducto">
                  <span>Guardar</span>
                  <i class="fa fa-circle-check"></i>
                </button>
              </section>
            </vue-final-modal>
          </div>
          <div class="page__table">
            <div class="table-headers">
              <p>Código de productos</p>
              <p>Nombre de producto</p>
              <p>Descripción</p>
              <p>Estado</p>
              <p>Acción</p>
            </div>
            <div class="table-body">
              <div class="data" v-for="product of searchAgregado" :key="product.product_code">
                <p>{{ product.product_code }}</p>
                <p>{{ product.product_name }}</p>
                <p>{{ product.product_descripcion }}</p>
                <p>
                  <div class="dropdown-item-special">
                    Activado
                    <input
                        :id="'check_'+product.id"
                        type="checkbox"
                        :checked="product.product_status"
                        class="dropdown-checkbox"
                        @change="changeStatus($event, product)"
                    />
                    <label class="wrapper" :for="'check_'+product.id">
                      <span class="circle"></span>
                    </label>
                  </div>
                </p>
                <p>
                  <svg @click="deleteProduct(product)" xmlns="http://www.w3.org/2000/svg" class="h-1 w-1 button_delete" viewBox="0 0 20 20" fill="red">
                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                  </svg>
                </p>
              </div>
              <div style="text-align: center;" v-if="empty_searchAgregado">
                <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
              </div>
            </div>
            <br>
            <div class="page__pagination">
              <Pagination
                  :data="paginationPrincipal"
                  v-on:changePage="handleClickInParent"
              />
            </div>
          </div>

        </section>
        <section class="page__actions">
          <button class="" @click="exitBranchOffice()">
            <span>Cancelar</span>
            <i class="fa fa-times-circle"></i>
          </button>
          <button @click="saveBranchOffice">
            <span>Guardar</span>
            <i class="fa fa-circle-check"></i>
          </button>
        </section>

      </div>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src

import axios from "axios";
import GoogleMaps from "../../components/GoogleMaps";
import Navbar from "../../components/NavBar";
import { VueFinalModal } from 'vue-final-modal'
import Pagination from '@/components/Pagination.vue'
import {
  codeFormat,
  dateFormat,
  conditionalFormatValue
} from '@/utils/formats'
  import OpenArrow from '@/components/OpenArrow.vue'
  import CommercialSidebar from '@/components/CommercialSidebar.vue'

export default {
  name: 'ClientAddBranchOffice',
  components: {
    Navbar,
    GoogleMaps,
    VueFinalModal,
    Pagination,
    OpenArrow,
    CommercialSidebar
  },
  data(){
    return{
      columns: [
        {
          label: "Código de productos",
          field: "product_code",
          dataFormat: this.codeFormat,
        },
        { label: "Nombre de producto", field: "product_name" },
        { label: "Descripción", field: "product_descripcion" },
        { label: "Marca", field: "brand" },
        {
          label: "Imagen Cargada",
          field: "product_path",
          dataFormat: this.conditionalFormatValue,
        },
      ],
      hoy : new Date().toI,
      role: localStorage.getItem('role'),
      imagen:
          location.protocol +
          "//" +
          location.host +
          "/default/default_product.jpg",
      file: null,
      paginationPrincipal: [],
      branch_inside_mall: 0,
      sl_name: '',
      branch_direction: '',
      branch_code: '',
      branch_name: '',
      branch_nickname: '',
      branch_name_mall: '',
      branch_direction_mall: '',
      branch_reference: '',
      branch_description: '',
      branch_pais_id: 'Peru',
      branch_dep_id: "",
      branch_pro_id: '',
      branch_dis_id: '',
      branch_products: [],
      ubigeo: '',
      branch_length: '100',
      branch_latitude: '100',
      branch_status: '1',
      branch_company_id: 1,
      departments:[],
      provinces: [],
      provincesOptions:[],
      districts: [],
      districtsOptions:[],
      productos: [],
      pagination: [],
      searchAgregado: [],
      productos_check: [],
      showModal: false,
      nombre_productoAgregado:'',
      product_image:'',
      product_code:'',
      nombre_producto:'',
      product_brand:'',
      empty: false,
      empty_searchAgregado: false,
      brand: null,
      center: { lat: -12.046374026071097, lng: -77.04276187021284 },
      markers: [
        {
          position: {
            lat: -12.046374026071097,
            lng: -77.04276187021284,
          },
        },
      ],
    }
  },
  computed:{
    searchAgregado: function () {
      let listado = this.searchAgregado.filter((item) =>
          item.product_name
              .toLowerCase()
              .includes(this.nombre_productoAgregado.toLowerCase())
      );
      this.empty_searchAgregado = (listado.length === 0)
      return listado
    },
  },
  mounted() {
    this.company_name = localStorage.getItem('company_name');
    $('.vue-map').addClass("vue-map-change");
    if (localStorage.getItem('token')){
      this.handleClickInParent()
      const valores = window.location.search;
      const urlParams = new URLSearchParams(valores);
      axios.get("general/elements/brand").then((res) => {
        this.brand = res.data.data;
      });
      var id = urlParams.get('id');
      let result = axios.get("general/branchoffice/"+id).then(res => {
        this.searchAgregado = res.data.data.allproducts
        this.empty_searchAgregado = (res.data.data.products.total === 0)
        this.branch_products = res.data.data.products
        this.branch_code = res.data.data.branch_code
        this.branch_inside_mall = res.data.data.branch_inside_mall
        this.branch_direction_mall = res.data.data.branch_direction_mall
        this.branch_name_mall = res.data.data.branch_name_mall
        this.branch_direction = res.data.data.branch_direction
        this.branch_code = res.data.data.branch_code
        this.branch_name = this.name_sucursal = res.data.data.branch_name
        this.imagen = res.data.data.branch_file
        this.branch_nickname = res.data.data.branch_nickname
        this.branch_reference = res.data.data.branch_reference
        this.branch_description = res.data.data.branch_description
        this.branch_dep_id = res.data.data.branch_dep_id
        this.branch_pro_id = res.data.data.branch_pro_id
        this.branch_dis_id = res.data.data.branch_dis_id
        this.ubigeo = res.data.data.ubigeo
        this.branch_length = res.data.data.branch_length
        this.branch_latitude = res.data.data.branch_latitude
        this.center.lat = parseFloat(res.data.data.branch_latitude)
        this.center.lng = parseFloat(res.data.data.branch_length)
        this.markers[0].position.lat = parseFloat(res.data.data.branch_latitude)
        this.markers[0].position.lng = parseFloat(res.data.data.branch_length)
      })
      this.getUbigeo()
    }else{
      this.$router.push('/login');
    }
  },
  methods:{
    onlynumber(evt){
      evt = (evt) ? evt : window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    clean_filters_modal(){
      this.product_image = ''
      this.product_brand = ''
      this.nombre_producto = ''
      this.product_code = ''
      this.getall()
    },
    changeStatus(e, id){
      let activado = (e.target.checked) ? 1 : 0
      this.searchAgregado.filter((item,key) => {
        if(item === id){
          this.searchAgregado[key].product_status = activado
        }
      })
    },
    saveProducto(event, id){
      if (event.target.checked){
        this.productos_check.push(id)
      }else{
        this.productos_check = this.productos_check.filter((item) => item !== id)
      }
    },
    deleteProduct(id) {
      if (this.productos_check) {
        this.productos_check = this.productos_check.filter((item) => item !== id)
      }

      for (var i = 0; i < this.searchAgregado.length; i++) {
        if (this.searchAgregado[i].id === id.id) {
          this.searchAgregado.splice(i, 1);
        }
      }

      if (this.searchAgregado.length === 0){
        this.empty_searchAgregado = true
      }
    },
    exitBranchOffice(){
      this.$router.push('/')
    },
    handleClickInParent: function(page) {
      this.getall(page)
    },
    filterProducto(){
      if (this.productos_check){
        this.productos_check.forEach(item=>{
          this.searchAgregado.push(item)
        })
      }
      this.productos_check = this.productos_check.filter((item) => item === 'clear')
      this.showModal = false;
      if (this.searchAgregado.length !== 0){
        this.empty_searchAgregado = false
      }
    },
    closeModal () {
      this.showModal = false
    },
    codeFormat,
    dateFormat,
    conditionalFormatValue,
    search: function () {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(
          function () {
            let paramSearch = {
              product_code: self.product_code,
              nombre_producto: self.nombre_producto,
              marca: self.product_brand,
              imagen: self.product_image,
            };
            this.getall(1, paramSearch);
          }.bind(this),
          500
      );
    },
    async getall(page = 1, paramSearch = {}) {

      var tempProduct = ''
      this.searchAgregado.forEach((item,index) =>{
        if(index===0){
          tempProduct = item.id.toString()
        }else {
          tempProduct = tempProduct + ','+  item.id.toString()
        }
      })

      await axios.get('general/product', {
        params: {
          not: (tempProduct) ? tempProduct : null,
          page: page,
          product_company_id: localStorage.getItem("company_id"),
          product_code: paramSearch.product_code,
          product_name:
              paramSearch.nombre_producto !== ""
                  ? paramSearch.nombre_producto
                  : null,
          product_brand_id: paramSearch.marca,
          imagen: paramSearch.imagen,
        },
      }).then( res => {
        if (res.data.data.total > 0){
          this.productos = res.data.data.data
          this.empty = false
          this.pagination = res.data.data;
        }else{
          this.productos = {}
          this.pagination = {};
          this.empty = true
        }
      })
    },
    showModalFront() {
      this.showModal = true;
      this.getall(1)
    },
    change_file(event){
      if (typeof event.target.files[0] !== "undefined"){
        this.file = event.target.files[0]
        let reader = new FileReader()
        if (event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/jpg') {
          reader.onload = (e) => {
            this.imagen = e.target.result
          }
        } else {
          this.$swal({
            position: 'top-end',
            icon: 'error',
            title: 'El archivo no es un formato de imagen',
            showConfirmButton: false,
            timer: 2000
          })
        }
        reader.readAsDataURL(this.file)
      }
    },
    deleteImagen(){
      this.$refs.fileupload.value = null;
            this.imagen =
        location.protocol +
        "//" +
        location.host +
        "/default/default_product.jpg";
    },
    localizacion() {
      var temp = this.$refs.mapRef.$mapObject.rmiUrl;
      var longitude = temp.substring(30, 40);
      var latitude = temp.substring(40, 52);
      this.branch_latitude = longitude.replace(",", "");
      this.branch_length = latitude.replace(",", "");
    },
    async localizacion(){
      var temp = this.$refs.mapRef.$mapObject
      var ta = JSON.parse(JSON.stringify(this.$refs.mapRef.$mapObject.center));
      this.branch_latitude = ta.lat
      this.branch_length = ta.lng
      let json = {
        latitud: this.branch_latitude,
        longitud: this.branch_length,
      }
      await axios.post("general/branchoffice/location", json)
        .then(res => {
          this.branch_dep_id = res.data.data.departamento_id
          this.branch_pro_id = res.data.data.provincia_id
          this.branch_dis_id = res.data.data.distrito_id
          this.ubigeo = res.data.data.ubigeo

          
        this.dataDepartamento();
        this.dataProvincia();
        this.dataUbigeo();
        })
    },
    async showAlert() {
      const { value: formValues } = await this.$swal.fire({
        title: 'Lista de producto',
        html:this.tableHmtl,
        focusConfirm: false,
        preConfirm: () => {
          var temp = []
          this.productos.forEach(item =>{
            var tempFormValues = String(item.id)
            temp.push({
              item: item,
              formValues:document.getElementById(tempFormValues).checked
            })
          })
          return temp;
        }
      })
      formValues.forEach(item=>{
        if (item.formValues === true)
          this.branch_products.push(item.item)
      })
      if (formValues) {
        let success = true;
        formValues.forEach(item =>{
          if (item === '') {
            this.$swal.fire('Error', 'No completo todos los datos', 'error')
            success = false;
          }
        });
        if (success) {
          this.$swal.fire('Producto Agregado', '', 'success')
        }
      }
    },
    dataDepartamento(){
      var temporal=[];
      this.provinces.forEach(item=>{
        if((item.department_id)===this.branch_dep_id)
          temporal.push(item);
      })
      this.provincesOptions=temporal;
      this.districtsOptions=temporal;
      this.ubigeo = "";
    },
    dataProvincia(){
      var temporal=[];
      this.districts.forEach(item=>{
        if((item.province_id)===this.branch_pro_id)
          temporal.push(item);
      })
      this.districtsOptions=temporal;
    },
    dataUbigeo() {
      this.ubigeo = this.branch_dis_id;
    },
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    async getUbigeo(){
      let result = await axios
          .get("general/ubigeo")
          .then(res => {
            this.departments = res.data.data.department
            this.provinces = res.data.data.province
            this.districts = res.data.data.district
            this.dataDepartamento()
            this.dataProvincia()
            this.dataUbigeo()
          })
      const { data } = await axios.get('general/product')
      this.productos = data.data.data;
      let products = data.data.data;
      let htmlProduct = '<table border="1" id="table123"> <tr> <th>Código de productos</th> <th>Nombre de producto</th> <th>Descripción</th> <th>Tipo de producto</th> <th>Marca</th> <th>Accion</th> </tr>';
      products.forEach(item =>{
        let htmlTemporal = '<tr><td>' +item.product_code+ '</td> <td>' +item.product_name+ '</td> <td>' +item.product_descripcion+ '</td> <td>' +item.type+ '</td> <td>' +item.brand+ '</td> <td><input id="' +item.id+ '" type="checkbox"  value="' +item.id+ '"></td> </tr>'
        htmlProduct = htmlProduct + htmlTemporal
      })
      htmlProduct = htmlProduct + '</table>'
      this.tableHmtl = htmlProduct

    },
    async saveBranchOffice() {

      var tempProduct = ''
      this.searchAgregado.forEach((item, index) => {
        if (index === 0) {
          tempProduct = item.id.toString()+':'+item.product_status;
        } else {
          tempProduct = tempProduct + "," + item.id.toString()+':'+item.product_status;
        }
      });

      const valores = window.location.search;
      const urlParams = new URLSearchParams(valores);
      var id = urlParams.get('id');

      const formData = new FormData();

      formData.append('branch_code', this.branch_code);
      formData.append('branch_name', this.branch_name);
      formData.append('branch_nickname', this.branch_nickname);
      formData.append('branch_description', this.branch_description);
      formData.append('branch_direction', this.branch_direction);
      formData.append('branch_name_mall', this.branch_name_mall);
      formData.append('branch_direction_mall', this.branch_direction_mall);
      formData.append('branch_reference', this.branch_reference);
      formData.append('branch_inside_mall', this.branch_inside_mall);
      formData.append('file', this.file);
      formData.append('branch_dep_id', this.branch_dep_id);
      formData.append('branch_pro_id', this.branch_pro_id);
      formData.append('branch_dis_id', this.branch_dis_id);
      formData.append('ubigeo', this.ubigeo);
      formData.append('branch_latitude', this.branch_latitude);
      formData.append('branch_length', this.branch_length);
      formData.append('branch_status', this.branch_status);
      formData.append('products', tempProduct);

    const response = await axios.post('general/branchoffice/branchoffice/'+id, formData)
      if(response.status === 200){
        this.$swal({
          position: 'center',
          icon: 'success',
          title: 'Sucursal actualizo correctamente',
          showConfirmButton: false,
          timer: 2000
        })
        this.$router.push('/')
      }
    }
  }
}


</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  height: 100%;
  overflow-y: auto;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
#input_file {
  cursor: pointer;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
}
/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}
.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: auto;
  display: flex;
}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  height: auto;
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 50px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}
/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: auto;
}
.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}
.body__containt .page__title h2 span {
  color: #ff3128;
}
.body__containt .page__subtitle h3  {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}
.body__containt .page__filters .input:nth-child(5) {
  /*margin-right: 320px;*/
}
.body__containt .page__filters.first .input:nth-last-child(1) {
  width: 1260px;
}
.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select, textarea{
  outline:none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
  border-bottom: 1px solid #938f8f;
}
/*eliminar*/
.ubicacion__image{
  /*display: flex;*/
  /*border-radius: 10px;*/
  /*overflow: hidden;*/

}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.ubicacion__buttons button{
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.ubicacion__buttons{
  margin-top: 2%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.lista_productos__buttons button{
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}

/*------BODY------*/

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-evenly;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 17px;
  left: 2px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32ba7c;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.dropdown-checkbox {
  display: none;
}

.dropdown-checkbox:checked + .wrapper {
  background-color: #32ba7c;
}

.dropdown-checkbox:checked + .wrapper > .circle {
  left: 15px;
}

.wrapper {
  width: 31px;
  height: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-left: 1rem;
  position: relative;
  border-radius: 30px;
  background-color: #cbcbcb;
}

.circle {
  left: 0;
  width: 15px;
  height: 15px;
  transition: 0.2s;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
}
.button_delete{
  width: 2rem;
}
/*check*/
input[type="checkbox"] {
  width: 100%;
  height: 20px;
}
/*dropdown*/
.dropdown {
  display: flex;
  margin: 10px 0;
  font-weight: 300;
  position: relative;
  align-items: center;
  width: calc(100% / 7);
  justify-content: center;
}

.button {
  background: none;
  border: 0;
  color: inherit;
  outline:none;
}

.dropdown-item {
  height: 50px;
  display: flex;
  cursor: pointer;
  align-items: center;
}

.dropdown-item:active {
  color: inherit;
  background-color: inherit;
}

.dropdown-item svg {
  color: red;
  font-size: 1.2rem;
  margin-right: 0.8rem;
}

.dropdown-item-special {
  height: 60px;
  display: flex;
  padding: 1rem;
  font-weight: 400;
  align-items: center;
  justify-content: flex-end;
}

.dropdown-checkbox {
  display: none;
}

.dropdown-checkbox:checked + .wrapper {
  background-color: #32ba7c;
}

.dropdown-checkbox:checked + .wrapper > .circle {
  left: 15px;
}

.wrapper {
  width: 31px;
  height: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-left: 1rem;
  position: relative;
  border-radius: 30px;
  background-color: #cbcbcb;
}

.circle {
  left: 0;
  width: 15px;
  height: 15px;
  transition: 0.2s;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
}
.body__sidebar.open{
    display: none;
  }
  .back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}
</style>
